<template>
    <div class="filter-chip-container">
        <div v-for="(chip, index) in chips" :key="'chip' + index" class="filter-chip">
            <div class="chip-holder">
                <span class="display-text">{{ chip.label }} <span class="comparator-text">{{ chip.compatator }}</span> {{ getChipValue(chip) }}</span>
                <div class="chip-close-btn-container">
                    <div class="chip-close-btn" @click="removeChip(chip, index)">
                        <i class="fas fa-times close-icon" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    data() {
        return {
        };
    },
    computed: {
        ...mapGetters([
            "generalFilter",
        ]),
        chips() {
            if (this.generalFilter && this.generalFilter.length > 0) {
                return this.generalFilter.filter(item => item.isDisplayInChip == true);
            }
        }
    },
    methods: {
        getChipValue(chip) {
            if (chip.formatter) return chip.formatter(chip.value);
            else return chip.value || "-";
        },
        removeChip(chip, index) {
            let temp_data_filter = Object.assign(this.generalFilter, {});
            temp_data_filter.splice(index, 1);
            this.$store.dispatch("general_filter/applyGeneralFilter", temp_data_filter);
        }
    }
};
</script>

<style lang="css" scoped>
.filter-chip-container {
    margin-bottom: var(--space-8);
}
.filter-chip {
    background-color: var(--chip-bg-grey);
    padding: var(--space-4) var(--space-8);
    display: inline-block;
    border-radius: var(--space-12);
    margin-right: var(--space-8);
    margin-bottom: var(--space-8);
}
.chip-holder {
    display: flex;
    align-items: center;
}
.filter-chip .display-text{
    font-size: 12px;
    color: var(--main-color-1);
    margin-right: 8px;
    line-height: 12px;
}
.chip-close-btn-container {
    display: inline-block;
}
.chip-close-btn {
    display: flex;
    justify-content: center;
    align-self: center;
    background-color: var(--chip-close-btn);
    width: 16px;
    height: 16px;
    border-radius: 10px;
}
.chip-close-btn:hover{
    cursor: pointer;
    background-color: var(--chip-close-btn-hover);
}
.close-icon {
    font-size: 9px;
    line-height: 9px;
    margin: auto;
}
.comparator-text {
    font-weight: 700;
}
</style>


// WEBPACK FOOTER //
// src/components/Chip/GeneralFilterChip.vue